var map = {
	"./ArrowIcon.svg": 6437,
	"./IIITK_logo.png": 2751,
	"./IIITK_logo1.png": 3862,
	"./barcode.png": 3441,
	"./hamburger.svg": 1180,
	"./ics assignment 2.pdf": 851,
	"./iit_palakkad.jpeg": 8842,
	"./linkedin.svg": 6049,
	"./linkedin1.svg": 4642,
	"./logo.png": 6928,
	"./logo1.png": 4971,
	"./mail.svg": 9814,
	"./mail1.svg": 219,
	"./mozilla.jpg": 961,
	"./volkswagen.jpg": 9116,
	"./website.svg": 9386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;